// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"825588d2","82":"f8732c9e","247":"0785cca3","284":"ea812ad3","453":"75d5ea3a","551":"e87ce35d","627":"547cca46","867":"19fd3d9d","923":"f8008700","938":"44217183","950":"126eb716"}[chunkId] + ".chunk.js";
};